<template>
    <div class="print:hidden mx-1">
        <transition-group
        tag="div"
        enter-active-class="duration-400 ease-out"
        enter-from-class="transform opacity-0 -translate-y-10"
        enter-to-class="opacity-100"
        leave-active-class="duration-400 ease-out absolute"
        leave-from-class="opacity-100"
        leave-to-class="transform opacity-0 -translate-y-10"
        move="transition-all duration-400 ease"
        >
            <div class="transition-all duration-300 ease-out" key="company-info">
                <div
                class="flex flex-row justify-between items-center pb-0.5 border-b mx-1.5 border-b-gray-400"
                >
                <!-- <h3 class="text-sm">Client Info:</h3> -->
                <base-button-affirmative @click="resetFilters" class="text-xs -py-2"
                    >Clear filters</base-button-affirmative
                >
                </div>
                <div
                class="pt-1 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 2xl:grid-cols-8"
                id="company-info"
                >
                <base-filter @click="setClientOptions" :active="engagementFilters.client.value.length > 0">
                    <template v-slot:label> Client </template>
                    <template v-slot:widget>
                    <BaseComboBox
                        class="w-full rounded-b-md text-black"
                        v-model="engagementFilters.client.value"
                        :options="engagementFilters.client.options"
                        @update:modelValue="setClientFilter"
                        :multiple="true"
                    />
                    </template>
                </base-filter>
                <base-filter :active="!!engagementFilters.status.value">
                    <template v-slot:label> Status </template>
                    <template v-slot:widget>
                    <base-list-box
                        class="w-full rounded-b-md text-black"
                        v-model="engagementFilters.status.value"
                        :options="engagementFilters.status.options"
                        :multiple="false"
                    />
                    </template>
                </base-filter>
                <base-filter :active="!!engagementFilters.tailStatus.value">
                    <template v-slot:label>Tail Status </template>
                    <template v-slot:widget>
                    <base-list-box
                        class="w-full rounded-b-md text-black"
                        v-model="engagementFilters.tailStatus.value"
                        :options="engagementFilters.tailStatus.options"
                        :multiple="false"
                    />
                    </template>
                </base-filter>
                <base-filter :active="!!engagementFilters.shouldInvoice.value">
                    <template v-slot:label> Should Invoice </template>
                    <template v-slot:widget>
                    <base-list-box
                        class="w-full rounded-b-md text-black"
                        v-model="engagementFilters.shouldInvoice.value"
                        :options="engagementFilters.shouldInvoice.options"
                        :multiple="false"
                    />
                    </template>
                </base-filter>
                <base-filter :active="!!engagementFilters.retainerOn.value">
                    <template v-slot:label> Retainer On </template>
                    <template v-slot:widget>
                    <base-list-box
                        class="w-full rounded-b-md text-black"
                        v-model="engagementFilters.retainerOn.value"
                        :options="engagementFilters.retainerOn.options"
                        :multiple="false"
                    />
                    </template>
                </base-filter>
                </div>
            </div>
        </transition-group>
        <div>
        <div class="flex flex-wrap items-center space-x-2 mx-1.5">
          <div class="group flex justify-start items-center space-x-2">
            <h3 class="text-sm">Active Filters:</h3>
          </div>
          <base-pill class="bg-amber-300 flex items-center justify-between text-xs space-x-2 p-2 mb-0.5 " v-for="filter in activeFilters" :key="filter.name">
          <div> {{ filter.name }}: {{ filter.value }} </div><button @click="clearFilter(filter.filter)">✕</button> 
          </base-pill>
        </div>
      </div>
    </div>
</template>

<script>
export default {
    name: 'engagement-filters'
}
</script>

<script setup>
import { ref, watch, reactive, defineEmits, computed } from 'vue';
import {useStore} from 'vuex'
import { getAllClientsSimple } from '@/services/Client';
import BaseComboBox from '../BaseComboBox.vue'

const store = useStore()

const emit = defineEmits([
  "change-engagement-filters",
]);

const engagementFilters = reactive({
    client: {
        name: "Client",
        value: [],
        defaultValue: [],
        options: [
      {value: "clear", label: "------------"}
    ]
    },
    tailStatus: {
        name: "Tail Status",
        value: null,
        defaultValue: null,
        options: [
            {value: null, label: "------------"},
            {value: "before_tail_period", label: "Before Tail Period"},
            {value: "in_tail_period", label: "In Tail Period"},
            {value: "after_tail_period", label: "After Tail Period"},
        ],
    },
    status: {
        name: "Status",
        value: "active",
        defaultValue: "active",
        options: [
      {value: null, label: "------------"},
      {value: "active", label: "active"},
      {value: "inactive", label: "inactive"},
      {value: "paused", label: "paused"},
    ]
    },
    shouldInvoice: {
        name: "Should Invoice",
        value: "True",
        defaultValue: "True",
        options: [
            {value: null, label: "------------"},
            {value: "True", label: "True"},
            {value: "False", label: "False"},
        ]
    },
    retainerOn: {
        name: "Retainer On",
        value: "True",
        defaultValue: "True",
        options: [
            {value: null, label: "------------"},
            {value: "True", label: "True"},
            {value: "False", label: "False"},
        ]
    }
})

const filterValues = computed(() => {
    let values = []
    for(const filter in engagementFilters){
        values.push(engagementFilters[filter].value)
    }
    return values
})


async function setClientOptions() {
      const token = store.state.auth.token
      const result = await getAllClientsSimple({token: token})
      engagementFilters.client.options = [{value: "clear", label: "------------"}, ...result.data.map((client) => {
        return {value: client.id, label: client.client_name}
      })]
    }

function setClientFilter(target) {
      if(target.includes("clear")){
        engagementFilters.client.value = []
      }
    }


watch(filterValues, () => {
    console.log('filters changed')
    emitFiltersChanged()
}, {deep: true})

function emitFiltersChanged(){
    emit("change-engagement-filters", engagementFilters)
}

function resetFilters() {
    // Clear every filter to its empty state so ALL engagements show.
    // (Previously this reset to defaults like status=active / should_invoice=True
    // / retainer_on=True, which hid paused, non-invoicing, or non-retainer
    // engagements even though the user expected "clear" to show everything.)
    for(const filter in engagementFilters){
        engagementFilters[filter].value = Array.isArray(engagementFilters[filter].value) ? [] : null
    }
}

function clearFilter(filterName) {
    if(Array.isArray(engagementFilters[filterName].value)){
        engagementFilters[filterName].value = []
    } else {
        engagementFilters[filterName].value = null
    }
}

const activeFilters = computed(() => {
    let activeFilterArr = []
    for(const filter in engagementFilters) {
        if(Array.isArray(engagementFilters[filter].value) && engagementFilters[filter].value.length > 0){
            // console.log('found array')
            activeFilterArr.push({filter: filter, name: engagementFilters[filter].name, value: engagementFilters[filter].options.filter(option => engagementFilters[filter].value.includes(option.value)).map(option => option.label)})
        } else if (!Array.isArray(engagementFilters[filter].value) && engagementFilters[filter].value) {
            activeFilterArr.push({filter: filter, name: engagementFilters[filter].name, value: engagementFilters[filter].value})
        }
    }
    return activeFilterArr
})

setClientOptions()

</script>